'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDashboardBuilder, iconDashboardBuilderTag } from '@ni/nimble-components/dist/esm/icons/dashboard-builder';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDashboardBuilder };
export { iconDashboardBuilderTag };
export const NimbleIconDashboardBuilder = wrap(IconDashboardBuilder);